<!-- Backdrop for expanded video -->
<div 
  *ngIf="isVisible() && isExpanded()" 
  class="video-backdrop"
  (click)="onExpand()">
</div>

<div 
  *ngIf="isVisible()" 
  class="floating-video-container"
  [class.expanded]="isExpanded()"
  [class.loaded]="isVideoLoaded()">
  
  <!-- Video Section -->
  <div class="video-section">
    <!-- Close Button -->
    <button class="close-btn" (click)="onClose()" aria-label="Close video">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <!-- Expand/Collapse Button -->
    <button class="expand-btn" (click)="onExpand()" [attr.aria-label]="isExpanded() ? 'Collapse video' : 'Expand video'">
      <svg *ngIf="!isExpanded()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>
      </svg>
      <svg *ngIf="isExpanded()" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M9 9h6v6m-7 4H5a2 2 0 0 1-2-2v-3m18 0v3a2 2 0 0 1-2 2h-3m0-18h3a2 2 0 0 1 2 2v3M3 8V5a2 2 0 0 1 2-2h3"></path>
      </svg>
    </button>

    <!-- Video Container -->
    <div class="video-container">
      <div *ngIf="!isVideoLoaded()" class="loading-overlay">
        <div class="loading-spinner"></div>
        <p>Loading video...</p>
      </div>
      
      <iframe 
        *ngIf="safeEmbedUrl()"
        [src]="safeEmbedUrl()"
        class="instagram-embed"
        frameborder="0"
        allowtransparency="true"
        allowfullscreen
        allow="autoplay; fullscreen; encrypted-media; clipboard-write"
        sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
        loading="eager"
        (load)="onVideoLoaded()">
      </iframe>
    </div>
  </div>
</div>
